const config = {
  mainTitle: 'Staff Management',
  subHeading: 'Manage your centre staff details here',
  titleIcon: 'IosPeople'
}

export default config
